import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

/**
 * Typed confirmation for advert deletion (epic AC: the admin must type "delete").
 * Soft delete server-side — the advert only, never the app row.
 */
const DeleteAdvertModal = ({ advert, error, onConfirm, onCancel }) => {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    setTyped('');
  }, [advert]);

  return (
    <Modal isOpen={!!advert} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>Delete app advert</ModalHeader>
      <ModalBody>
        <p>
          This removes <strong>{advert ? advert.name : ''}</strong> from the App Store listing. The linked
          app itself is not affected.
        </p>
        <p className="mb-2">
          Type <strong>delete</strong> to confirm:
        </p>
        <Input value={typed} onChange={e => setTyped(e.target.value)} placeholder="delete" />
        {/* A failed delete used to land in the page-level banner BEHIND this backdrop, so the button looked like it
            had done nothing; the message belongs where the action is, and the button stays live to retry. */}
        {error ? (
          <Alert color="danger" className="mt-3 mb-0">
            {error}
          </Alert>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        {/* Trimmed and case-insensitive: the word is the deliberate act, and a trailing space
            from a paste used to leave the button disabled with nothing on screen saying why. */}
        <Button color="danger" disabled={typed.trim().toLowerCase() !== 'delete'} onClick={onConfirm}>
          Delete advert
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteAdvertModal;
